var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('td',{staticClass:"cell"},[_c('StatementAvatar',{attrs:{"icon-name":_vm.iconName,"type":_vm.type,"size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }